import { useState } from "react";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MetaAdRow from "./MetaAdRow";
import { useFormContext } from "react-hook-form";

import {
  AD_GROUP,
  VALUE_NUMBER,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  VALUE_WITH_PERCENTAGE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import { expanderColumnSx, metricColumnSx } from "../columnWidths";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const MetaAdGroupRow = ({
  indexCampaign,
  adGroupID,
  indexAdGroup,
  data,
  adsStatistics,
  sortConfig,
  columns,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslationApp();

  const { campaign, getCostByMainCurrency } = useFormContext();
  const adsGroups = campaign.adsGroups || [];
  const foundAdGroup = adsGroups.find((adGroup) => adGroup.id === adGroupID);

  // Sort ads
  const sortedAds = Object.entries(adsStatistics).sort((a, b) => {
    const adData1 = a[1];
    const adData2 = b[1];
    if (sortConfig.key) {
      const comparison =
        (adData1[sortConfig.key] || 0) - (adData2[sortConfig.key] || 0);
      return sortConfig.direction === "asc" ? comparison : -comparison;
    }
    return 0;
  });

  const { cost, currency } = getCostByMainCurrency({
    cost: data.spend,
    currency: data.currency,
  });

  const { cost: costPerMainAction, currency: currencyPerMainAction } =
    getCostByMainCurrency({
      cost: data.costPerMainAction,
      currency: data.currency,
    });

  return (
    <>
      <TableRow>
        <TableCell indexRow={indexCampaign} sx={expanderColumnSx} level={2}>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        {columns.map((col) => (
          <TableCell
            key={col.key}
            indexRow={indexCampaign}
            level={2}
            sx={metricColumnSx(col.width)}
          >
            {(() => {
              switch (col.key) {
                case "platform":
                  return (
                    foundAdGroup?.name || `${t(AD_GROUP)} ${indexAdGroup + 1}`
                  );
                case "spend":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: cost,
                    currency,
                  });
                case "impressions":
                  return t(VALUE_NUMBER, { value: data.impressions });
                case "reach":
                  return t(VALUE_NUMBER, { value: data.reach });
                case "click":
                  return t(VALUE_NUMBER, { value: data.click });
                case "ctr":
                  return t(VALUE_WITH_PERCENTAGE, { value: data.ctr });
                case "mainAction":
                  return t(VALUE_NUMBER, { value: data.mainAction });
                case "costPerMainAction":
                  return renderMetricValue(
                    costPerMainAction,
                    col.key,
                    currencyPerMainAction
                  );
                case "cpc":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: (data.cpc || 0).toFixed(2),
                    currency: data.currency,
                  });
                case "cpm":
                  return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                    value: (data.cpm || 0).toFixed(2),
                    currency: data.currency,
                  });
                default:
                  return renderMetricValue(
                    data[col.key],
                    col.key,
                    data.currency
                  );
              }
            })()}
          </TableCell>
        ))}
      </TableRow>
      {open &&
        sortedAds.map(([adID, adData], indexAd) => (
          <MetaAdRow
            key={adID}
            indexCampaign={indexCampaign}
            indexAdGroup={indexAdGroup}
            adGroupID={adGroupID}
            indexAd={indexAd}
            adID={adID}
            data={adData}
            columns={columns}
          />
        ))}
    </>
  );
};

export default MetaAdGroupRow;
